export const FORTUNE_MUTATION = {
  SET_HISTORY: 'setHistory',
  SET_COUNT: 'setCount',
  SET_CHANNEL_DATA: 'setChannelData',
  ADD_LOADING: 'addLoading',
  MINUS_LOADING: 'minusLoading'
}
